// extracted by mini-css-extract-plugin
export default {"normalXl2":"styles_normalXl2__cfsCm","normalXl":"styles_normalXl__ZJca2","normalLg":"styles_normalLg__Xs82p","normalMd":"styles_normalMd__RnNDX","normalSm":"styles_normalSm__1pEqi"};